/** The workspace's plant register for the "Coming up" list, read through the
 *  register's own cached list so Home adds no request when Plant was opened
 *  recently. Any failure (including a role without register access) just means
 *  no rows. Refetches when the date changes so an exam entering the window
 *  appears on a dashboard left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { PlantAsset } from '../../types/plant';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { localDayKey, lolerPlantAssetsRead } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly PlantAsset[] = [];

export function useLolerPlantAssets(workspaceId: string | undefined): readonly PlantAsset[] {
  const [dayKey, setDayKey] = useState(localDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(localDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? lolerPlantAssetsRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
